import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaClock } from 'react-icons/fa';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission here
    alert('Thank you for your message! We will get back to you soon.');
    setFormData({ name: '', email: '', phone: '', message: '' });
  };

  return (
    <section id="contact" className="section contact">
      <div className="container">
        <motion.h2 
          className="section-title"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          📞 Get In Touch
        </motion.h2>
        
        <div className="contact-content">
          <motion.div 
            className="contact-info"
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h3>Contact Information</h3>
            
            <div className="contact-item">
              <FaPhone style={{ color: '#667eea', fontSize: '1.2rem' }} />
              <div>
                <h4>Phone</h4>
                <p>+91 95037 00022</p>
              </div>
            </div>
            
            <div className="contact-item">
              <FaEnvelope style={{ color: '#667eea', fontSize: '1.2rem' }} />
              <div>
                <h4>Email</h4>
                <p>info@sanchitisfitness.com</p>
              </div>
            </div>
            
            <div className="contact-item">
              <FaMapMarkerAlt style={{ color: '#667eea', fontSize: '1.2rem' }} />
              <div>
                <h4>Address</h4>
                <p>Plot No 247 Canal Road</p>
                <p>Dharampeth Nagpur</p>
                <p>Maharashtra 440010</p>
              </div>
            </div>
            
            <div className="contact-item">
              <FaClock style={{ color: '#667eea', fontSize: '1.2rem' }} />
              <div>
                <h4>Studio Hours</h4>
                <p><strong>Monday - Friday:</strong> 8:00 AM - 9:00 PM</p>
              </div>
            </div>

            <div style={{ marginTop: '2rem' }}>
              <h3 style={{ marginBottom: '1rem' }}>Class Schedule</h3>
              <div style={{ background: 'white', padding: '1.5rem', borderRadius: '10px', boxShadow: '0 5px 15px rgba(0,0,0,0.1)' }}>
                <p><strong>🌅 Morning Classes:</strong> 8:00 AM, 9:00 AM</p>
                <p><strong>🌞 Afternoon Classes:</strong> 2:00 PM</p>
                <p><strong>🌙 Evening Classes:</strong> 7:00 PM, 8:00 PM</p>
                <p style={{ marginTop: '1rem', fontStyle: 'italic', color: '#666' }}>
                  Special meditation sessions every Sunday at 8:00 AM
                </p>
              </div>
            </div>
          </motion.div>
          
          <motion.div 
            className="contact-form"
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h3 style={{ marginBottom: '1.5rem', textAlign: 'center' }}>Send us a Message</h3>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Full Name *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="Enter your full name"
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="email">Email Address *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="Enter your email address"
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="phone">Phone Number</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Enter your phone number"
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="message">Message *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="5"
                  placeholder="Tell us about your yoga goals, questions, or how we can help you..."
                ></textarea>
              </div>
              
              <motion.button 
                type="submit" 
                className="submit-btn"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                🕉️ Send Message
              </motion.button>
            </form>
            
            <div style={{ marginTop: '2rem', textAlign: 'center', padding: '1rem', background: '#f8f9fa', borderRadius: '10px' }}>
              <p style={{ fontSize: '0.9rem', color: '#666' }}>
                <strong>New to yoga?</strong> Book your first class for free! 
                Mention "FIRST_CLASS_FREE" in your message.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
